module.exports = __webpack_public_path__ + "img/link-arrow.721eba35.svg";